import clsx from 'clsx';
import React, { createContext, useContext, useState } from 'react';
import styles from './InputGroup.module.scss';

interface InputGroupContextValue {
    isFocused: boolean;
    setFocused: (focused: boolean) => void;
}

const InputGroupContext = createContext<InputGroupContextValue | undefined>(undefined);

export const useInputGroupContext = () => {
    const context = useContext(InputGroupContext);
    if (!context) {
        throw new Error('InputGroup components must be used within an InputGroup');
    }
    return context;
};

interface InputGroupProps {
    children?: React.ReactNode;
    className?: string;
}

export const InputGroup: React.FC<InputGroupProps> = ({ children, className }) => {
    const [isFocused, setFocused] = useState(false);

    return (
        <InputGroupContext.Provider value={{ isFocused, setFocused }}>
            <div
                className={clsx(styles.root, className, {
                    [styles.focused]: isFocused
                })}
            >
                {children}
            </div>
        </InputGroupContext.Provider>
    );
};
